export const getSubCategoryTitle = (
  subCategoryTitle: Possible<string>,
): string => subCategoryTitle ?? 'Specialty';

export const CATEGORY_REMAP: Record<string, string> = {
  undergrad: 'college',
};

// TODO: remove this and confirm that the backend handles the mapping
export const categoryRedirectMapToSlug = (
  categorySlug: string,
  hasActiveCoach: boolean | undefined | null,
): string => {
  if (hasActiveCoach) {
    return categorySlug;
  }
  switch (categorySlug) {
    case 'accounting':
    case 'equity-research':
    case 'f-p-and-a':
    case 'financial-planning-advising':
    case 'hedge-fund':
      return 'private-equity';
    case 'customer-success':
    case 'customer-support':
    case 'design':
    case 'human-resources':
    case 'real-estate':
      return 'general-career';
    case 'cyber-security':
    case 'engineering-other':
      return 'software-engineering';
    case 'dental-career':
    case 'dentistry':
    case 'dat':
      return 'dental-school';
    case 'medicine-career':
      return 'medical-school';
    case 'product-operations':
      return 'business-strategy-and-operations';
    case 'sales-and-trading':
      return 'sales-strategy-and-operations';
    case 'technical-program-management':
      return 'product-management';
    default:
      return categorySlug;
  }
};
